import { projectDataType } from ".";

const crudeVesselsData: projectDataType = {
  path: "crudevessels",
  title: "Crude Vessels",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964733/Art-Site/CrudeVessels/crudevessels_wxark6.jpg",
  description: "Art Blog 2011 - present",
  year: 2011,
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964733/Art-Site/CrudeVessels/crudevessels_wxark6.jpg",
  ],
  link: "https://crudevessels.tumblr.com/",
};

export default crudeVesselsData;
